import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import { StickyAlertType } from '@/modules/alerts/models/sticky-alert-type';
import STICKY_ALERT_COMPONENT_REGISTRY from '@/modules/alerts/models/sticky-alert-component-registry';
import usePlatform from '@/modules/platform/composables/usePlatform';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCStickyAlertRoot',
  setup(__props) {

const { platform } = usePlatform();
const { alerts } = useStickyAlerts();

const getComponent = (alertType: StickyAlertType) => {
  return STICKY_ALERT_COMPONENT_REGISTRY[alertType];
};

const widthClass = computed(() => {
  return { 'w-100': !platform.value.isMobile };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex flex-column mt-2 px-2 container-xl sticky-alert-root", widthClass.value])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alerts), (alert) => {
      return (_openBlock(), _createElementBlock("div", {
        key: alert.props.id,
        class: "d-flex justify-content-center mb-2"
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(alert.stickyAlertType)), _mergeProps({ ref_for: true }, alert.props), null, 16))
      ]))
    }), 128))
  ], 2))
}
}

})